<div class="content">
  <div *ngIf="stepIndex === 0" class="step step-1">
    <h2>So funktioniert das Wiederholen einer Lernkarte</h2>
    <p>👀 Schaue dir die Lernkarte an und formuliere im Kopf eine Antwort.</p>
    <p>👉 Klicke auf die Karte, um die Antwort anzuzeigen.</p>
    <p>🌟 Bewerte, wie gut deine Antwort war.</p>
  </div>
  <div *ngIf="stepIndex === 1" class="step step-2">
    <h2>Wie oft werden Lernkarten wiederholt?</h2>
    <p>🔁 Sparkly nutzt Spaced Repetition.</p>
    <p>💡 Nach jeder Wiederholung berechnet ein Algorithmus, basierend darauf, wie gut du die Karte konntest, wann sie das nächste Mal abgefragt wird.</p>
  </div>
  <div *ngIf="stepIndex === 2" class="step step-3">
    <h2>Tipp: So lernst du am effektivsten 🧠</h2>
    <p>Vermeide es, einfach durchzuklicken – versuche wirklich, die Antwort im Kopf zu formulieren, bevor du die Lösung ansiehst. So merkst du dir den Stoff besser!</p>
  </div>
  <div class="buttons-container">
    <app-button *ngIf="stepIndex !== 0" [text]="'Zurück'" [style]="'outlined'" (clickEvent)="handlePrevClick()"></app-button>
    <app-button [text]="stepIndex !== 2 ? 'Weiter' : 'Ich bin bereit'" (clickEvent)="handleNextClick()"></app-button>
  </div>
</div>